import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import ManageLocationForm from '../../../components/SiteAdmin/ManageLocation/ManageLocationForm';
import Loader from '../../../components/Common/Loader/Loader';
import getLocation from './getLocation.graphql';
import { withQuery } from '../../../hoc/withGraphql';

export class EditLocation extends Component {

  static propTypes = {
    id: PropTypes.number.isRequired
  }
  static defaultProps = {
    data: {
      loading: true
    }
  }

  render() {

    const { formatMessage } = this.props.intl;
    const { data: { loading, getLocation }, data, id } = this.props;

    let initialValues = {};

    if (!loading && getLocation && getLocation?.result) {
      initialValues = {
        id: getLocation?.result?.id,
        locationName: getLocation?.result?.locationName,
        description: getLocation?.result?.description,
        path: JSON.parse(getLocation?.result?.coordinates),
        isActive: getLocation?.result?.isActive ? 1 : 0
      }
    }
    return (
      <Loader type={"page"} show={loading}>
        {!loading && <ManageLocationForm initialValues={initialValues} isEditForm />}
      </Loader>
    )
  }
}

export default compose(
  injectIntl,
  withQuery(getLocation, {
    options: (props) => ({
      variables: {
        id: Number(props.id)
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }))(EditLocation)
